import {client} from 'utils/api-client'

function register({data, captchaToken}) {
	return client('register', {data, captchaToken})
}

export {register}
